import React from 'react';
import { useTitle } from "fearless-common-ui";
import {Pages} from "../components/layout";
import {Link} from "react-router-dom";
import {routes} from "../utils";
/**
 * This page is used after sign up, but also after verify a new email
 * when replacing the current.
 */
export default function EmailVerified() {
    useTitle('Email verified');

    return (
        <Pages.Centred width="xs" className="text-center">
            <h1 className="mb-3">Email verified.</h1>
            <p>You can now <Link to={routes.login}>log in</Link>.</p>
        </Pages.Centred>
    );
}
